__turbopack_context__.v({
  "card": "EjAcca_card",
  "cardDescription": "EjAcca_cardDescription",
  "cardTag": "EjAcca_cardTag",
  "cardTitle": "EjAcca_cardTitle",
  "content": "EjAcca_content",
  "ctaContainer": "EjAcca_ctaContainer",
  "locationDisclaimer": "EjAcca_locationDisclaimer",
  "root": "EjAcca_root",
  "subtitle": "EjAcca_subtitle",
  "testListContainer": "EjAcca_testListContainer",
  "title": "EjAcca_title",
});
